import { cn } from "@/utils/utils"
import { cva, type VariantProps } from "class-variance-authority"

// `border` / `bg` / `shadow` live in the variants, not the base — otherwise a variant that wants
// no border has to undo one (which is how the soft card ended up with a grey outline).
const CardVariants = cva("flex h-full flex-col justify-between whitespace-break-spaces break-words rounded-3xl p-6", {
  variants: {
    variant: {
      /** White card, hairline border, soft drop shadow. The standard website-2.0 card. */
      default: "border border-neutral-20 bg-surface shadow-dropLight",
      /** Flat green tint, no border, no shadow — for panels sitting inside another card. */
      soft: "bg-primary-05",
      /** Green tint with a drop shadow — a soft card standing on its own, not nested in another card. */
      softElevated: "bg-primary-05 shadow-dropLight",
      surfaceElevated: "bg-surface shadow-elevation-1"
    }
  },
  defaultVariants: {
    variant: "default"
  }
})

type CardProps = VariantProps<typeof CardVariants> & {
  className?: string
  children?: React.ReactNode
}

export const CardBasic = ({ variant, className, children }: CardProps) => {
  return <div className={cn(CardVariants({ variant }), className)}>{children}</div>
}
